import { useMemo, useState } from 'react';
import { type RequestedDataGroup } from './useRequestedData';
import {
  parsePresentation,
  type ParseResult,
} from '../utils/parsePresentation';

export function useAppPresentation(
  presentationCompact: string,
  requestedDataGroups?: RequestedDataGroup[],
) {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const result: ParseResult = useMemo(
    () => parsePresentation(presentationCompact),
    [presentationCompact],
  );
  const isReady = !!requestedDataGroups && requestedDataGroups.length > 0;

  return { result, selectedIndex, setSelectedIndex, isReady };
}
